import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import projectData from '../data/projectData';
import '../styles/Portfolio.css';

const Portfolio = () => {
  useEffect(() => {
    document.title = 'Portfolio | Bularis Tech';
  }, []);

  return (
    <div className="portfolio">
      <div className="portfolio-header">
        <h1>Our Portfolio</h1>
        <p>Explore our past projects and see the work we've done for clients.</p>
      </div>
      <div className="portfolio-gallery">
        {projectData.map((project) => (
          <Link to={`/portfolio/${project.id}`} key={project.id} className="portfolio-item">
            {/* <img src={project.image} alt={project.title} /> */}
            <h3>{project.title}</h3>
            <p>{project.shortDesc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;